/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class AlarmTypeService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'AlarmTypeService\' loaded');
    }
}

export { AlarmTypeService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/alarm/service/AlarmTypeService.js